// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-header {
    background-color: transparent !important;
}

.backButtonLink {
    border: none !important;
    background: transparent !important;
    color: blue !important;
    box-shadow: none !important;
}

.backButtonLink:hover {
    border: none !important;
    background: transparent !important;
    color: #8432f0 !important;
    box-shadow: none !important;
}
.logo {
    position: relative;
    top: 0;
    left: 0;
}
.inputheight {
    height: auto !important;
}
.paddingleft {
    padding-left: 40px;
}

.paddingtop {
    padding-top: 40px;
}
.paddingtop10 {
    padding-top: 10px;
}

.paddingbottom10 {
    padding-bottom: 10px;
}

.is-invalid {
    border-left: solid 6px red;
}

.material-icons {
    display: inline-flex;
    vertical-align: middle;
}

.pac-container {
    z-index: 1001 !important;
}

.form-signin {
    max-width: 330px;
    padding: 15px;
}

@font-face {
    font-family: 'cabrion';
    src: url('Cabrion-Light.otf');
}
* {
    font-family: 'cabrion';
}
.login-wrapper {
    background: url('bg.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}

.login-card {
    padding: 100px 55px;
}

.fs-36 {
    font-size: 36px;
}
.fs-24 {
    font-size: 24px;
}

.fw-bold {
    font-weight: bold;
}
.text-gray {
    color: #a6a1b7;
}
.form-control {
    height: 55px;
    font-size: 18px;
}

.fs-14 {
    font-size: 14px;
}

.text-blue {
    color: #0f2d47;
}
.btn-blue {
    background-color: #0f2d47 !important;
    color: white !important;
    border-radius: 5px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

@media screen and (max-width: 1366.98px) {
    .login-wrapper {
        padding-top: 100px;
        padding-bottom: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .w-75 {
        width: 100% !important;
        margin: auto;
    }
    .logo {
        width: 200px;
        position: relative;
    }
    .login-card {
        padding: 50px 30px;
    }
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/login/forgot-password/forgot-password.component.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;AAC5C;;AAEA;IACI,uBAAuB;IACvB,kCAAkC;IAClC,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,kCAAkC;IAClC,yBAAyB;IACzB,2BAA2B;AAC/B;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,6BAAmD;AACvD;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAgD;IAChD,4BAA4B;IAC5B,sBAAsB;IACtB,2BAA2B;IAC3B,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI;QACI,kBAAkB;QAClB,qBAAqB;QACrB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,sBAAsB;QACtB,YAAY;IAChB;IACA;QACI,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;AACJ;;AAEA,opJAAopJ","sourcesContent":[".card-header {\n    background-color: transparent !important;\n}\n\n.backButtonLink {\n    border: none !important;\n    background: transparent !important;\n    color: blue !important;\n    box-shadow: none !important;\n}\n\n.backButtonLink:hover {\n    border: none !important;\n    background: transparent !important;\n    color: #8432f0 !important;\n    box-shadow: none !important;\n}\n.logo {\n    position: relative;\n    top: 0;\n    left: 0;\n}\n.inputheight {\n    height: auto !important;\n}\n.paddingleft {\n    padding-left: 40px;\n}\n\n.paddingtop {\n    padding-top: 40px;\n}\n.paddingtop10 {\n    padding-top: 10px;\n}\n\n.paddingbottom10 {\n    padding-bottom: 10px;\n}\n\n.is-invalid {\n    border-left: solid 6px red;\n}\n\n.material-icons {\n    display: inline-flex;\n    vertical-align: middle;\n}\n\n.pac-container {\n    z-index: 1001 !important;\n}\n\n.form-signin {\n    max-width: 330px;\n    padding: 15px;\n}\n\n@font-face {\n    font-family: 'cabrion';\n    src: url('../../../assets/fonts/Cabrion-Light.otf');\n}\n* {\n    font-family: 'cabrion';\n}\n.login-wrapper {\n    background: url('../../../assets/images/bg.png');\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n    min-height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.login-card {\n    padding: 100px 55px;\n}\n\n.fs-36 {\n    font-size: 36px;\n}\n.fs-24 {\n    font-size: 24px;\n}\n\n.fw-bold {\n    font-weight: bold;\n}\n.text-gray {\n    color: #a6a1b7;\n}\n.form-control {\n    height: 55px;\n    font-size: 18px;\n}\n\n.fs-14 {\n    font-size: 14px;\n}\n\n.text-blue {\n    color: #0f2d47;\n}\n.btn-blue {\n    background-color: #0f2d47 !important;\n    color: white !important;\n    border-radius: 5px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n@media screen and (max-width: 1366.98px) {\n    .login-wrapper {\n        padding-top: 100px;\n        padding-bottom: 100px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n    .w-75 {\n        width: 100% !important;\n        margin: auto;\n    }\n    .logo {\n        width: 200px;\n        position: relative;\n    }\n    .login-card {\n        padding: 50px 30px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
